(function () {
  'use strict';

  if (window.FotoMasterFormIdentity) return;

  var STORAGE_PREFIX = 'fm_active_lead_form_v1_';
  var MAX_AGE_MS = 4 * 60 * 60 * 1000;

  function generateFormId() {
    return 'frm_' + Date.now() + '_' + Math.floor(Math.random() * 100000);
  }

  function storageKey(formType) {
    return STORAGE_PREFIX + String(formType || 'contact').replace(/[^a-z0-9_-]/gi, '').toLowerCase();
  }

  function isValidRecord(record, now) {
    return record
      && /^frm_\d+_\d+$/.test(String(record.form_id || ''))
      && Number.isFinite(Number(record.created_at))
      && now - Number(record.created_at) >= 0
      && now - Number(record.created_at) < MAX_AGE_MS;
  }

  function getOrCreate(formType) {
    var key = storageKey(formType);
    var now = Date.now();
    var record = null;

    try {
      record = JSON.parse(window.sessionStorage.getItem(key) || 'null');
    } catch (_) {
      record = null;
    }

    if (!isValidRecord(record, now)) {
      record = {
        form_id: generateFormId(),
        created_at: now,
        last_seen_at: now
      };
    } else {
      record.last_seen_at = now;
    }

    try {
      window.sessionStorage.setItem(key, JSON.stringify(record));
    } catch (_) {}

    return record.form_id;
  }

  function complete(formType, formId) {
    var key = storageKey(formType);
    try {
      var record = JSON.parse(window.sessionStorage.getItem(key) || 'null');
      if (!record || String(record.form_id || '') === String(formId || '')) {
        window.sessionStorage.removeItem(key);
      }
    } catch (_) {
      try { window.sessionStorage.removeItem(key); } catch (_) {}
    }
  }

  window.FotoMasterFormIdentity = {
    getOrCreate: getOrCreate,
    complete: complete
  };
})();
